/** Markup Uiverse : wrap + 3 lignes (heading + 2 paragraphes). */
export function glowCardHtml(
  lines: { heading: string; middle: string; accent: string },
  options: {
    href?: string;
    wrapClass?: string;
    accentDataKpi?: string;
    previewHtml?: string;
    cardClass?: string;
  } = {}
): string {
  const kpiAttr = options.accentDataKpi ? ` data-kpi="${options.accentDataKpi}"` : '';
  const preview = options.previewHtml
    ? `<div class="card-glow-preview">${options.previewHtml}</div>`
    : '';
  const cardClass = `card-glow${options.previewHtml || options.cardClass ? ' card-glow--preview' : ''}${options.cardClass ? ` ${options.cardClass}` : ''}`;
  const inner = `
      ${preview}
      <p class="heading">${lines.heading}</p>
      <p>${lines.middle}</p>
      <p${kpiAttr}>${lines.accent}</p>`;
  const wrapClass = `card-glow-wrap${options.wrapClass ? ` ${options.wrapClass}` : ''}`;
  if (options.href) {
    return `<div class="${wrapClass}"><a href="${options.href}" class="${cardClass}">${inner}</a></div>`;
  }
  return `<div class="${wrapClass}"><article class="${cardClass}">${inner}</article></div>`;
}
